// Libraries
import React, { useEffect, useContext } from 'react';

// Services and Contexts
import LanguageContext from '../../contexts/LanguageContext';
import QuestionsContext from '../../contexts/QuestionsContext';

// Components
import QuestionBank from './components/QuestionBank';
import ScreenInfo from '../../components/ScreenInfo';

// Material-UI
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';

export default function Questionnaire() {
  const { translate } = useContext(LanguageContext);
  const { handleClearAllAnswers } = useContext(QuestionsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <ScreenInfo
        title="SCREEN_QUESTIONNAIRE_TITLE"
        description="SCREEN_QUESTIONNAIRE_INSTRUCTIONS"
      />
      <Box marginTop={-2} marginLeft={4} marginBottom={4}>
        <Button variant="outlined" onClick={handleClearAllAnswers}>
          {translate('UI_BUTTON_CLEAR_ALL_ANSWERS')}
        </Button>
      </Box>
      <Box textAlign="left">
        <QuestionBank />
      </Box>
    </Box>
  );
}
